import React from "react";
import { Link } from "react-router-dom";

const PaymentFailed = () => {
  return (
    <div className="w-full h-dvh">
      <div className="flex items-center justify-center flex-col h-full">
        <h1 className="lg:text-4xl md:text-4xl text-3xl font-bold text-center text-[#74716d]">
          Payment Failed
        </h1>
        <p className="text-center lg:mt-4 md:mt-3 mt-2 text-[#74716d]">
          Unfortunately, your payment could not be processed. Please try again
          <br />
          or contact our support team if the issue persists.
        </p>
        <Link
          to={"/"}
          className="btn btn-sm bg-[#c3a963] text-white hover:text-[#c3a963] hover:bg-[#ffffff] hover:no-underline font-thin mt-4"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PaymentFailed;
